export default '/build/0e09a50c.svg'